import * as React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

export const Post = ({ title, date, author, excerpt, slug, img, featured }) => {
  if (featured) {
    return (
      <Lede to={`/${slug}`}>
        {img ? <LedeCover image={img} alt={title} /> : null}
        <Meta>
          {date} · {author}
        </Meta>
        <Title $lede>{title}</Title>
        <Excerpt>{excerpt}</Excerpt>
        <More>Läs mer</More>
      </Lede>
    )
  }

  return (
    <Row to={`/${slug}`}>
      {img ? <Thumb image={img} alt={title} /> : null}
      <Body>
        <Meta>
          {date} · {author}
        </Meta>
        <Title>{title}</Title>
        <Excerpt>{excerpt}</Excerpt>
      </Body>
    </Row>
  )
}

const Meta = styled.p`
  margin-top: 1.15rem;
  font-size: 0.75rem;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--muted);
`

const Title = styled.h2`
  margin-top: 0.45rem;
  font-family: var(--font-serif);
  font-size: ${props => (props.$lede ? "clamp(1.75rem, 3vw, 2.45rem)" : "1.5rem")};
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.2;
`

const Excerpt = styled.p`
  margin-top: 0.7rem;
  color: var(--muted);
  font-size: 1rem;
  line-height: 1.6;
  max-width: 100%;
`

const More = styled.span`
  display: inline-block;
  margin-top: 0.85rem;
  font-size: 0.875rem;
  color: var(--accent);
`

const Lede = styled(Link)`
  display: block;
  padding-bottom: 2.25rem;
  border-bottom: 1px solid var(--border);
  text-decoration: none;
  color: inherit;

  &:hover h2 {
    color: var(--accent);
  }
`

const LedeCover = styled(GatsbyImage)`
  display: block;
  aspect-ratio: 16 / 8;
  width: 100%;
  border-radius: 0;

  img {
    border-radius: 0;
    object-fit: cover;
  }
`

const Row = styled(Link)`
  display: grid;
  gap: 1.25rem;
  padding: 1.75rem 0;
  border-bottom: 1px solid var(--border);
  text-decoration: none;
  color: inherit;

  @media ${props => props.theme.breakpoints.tablet} {
    grid-template-columns: 14rem minmax(0, 1fr);
    align-items: start;
    gap: 1.75rem;
  }

  &:hover h2 {
    color: var(--accent);
  }
`

const Thumb = styled(GatsbyImage)`
  display: block;
  aspect-ratio: 4 / 3;
  width: 100%;
  border-radius: 0;

  img {
    border-radius: 0;
    object-fit: cover;
  }
`

const Body = styled.div`
  ${Meta} {
    margin-top: 0;
  }
`
